<template>
	<div>
		<v-app-bar app color="black" dark fixed clipped-left clipped-right>
			<app-logo />
		</v-app-bar>
	</div>
</template>
<script>
import router from '@/open-router';
import series from 'to-series';
import AppLogo from '@/components/AppLogo';

export default {
	name: 'OpenNavigation',
	components: {
		AppLogo
	},

	data() {
		return {
		};
	},
	methods: {
	},
	computed: {
	},
	watch: {
	},
	created() {
	}
};
</script>
<style scoped>
a {
	color: white !important;
	text-decoration: none;
}

a div {
	color: white;
	text-decoration: none;
}

.v-toolbar__title,
a {
	font-family: "Montserrat" !important;
}

.left-nav .v-list-item__content {
	margin-left: -18px;
}

.left-nav .v-list-item__icon {
	width: 30px;
}

.iconWidth {
	width: 30px;
}
</style>